import {devLog} from "../../../../../../utils/devLog/devLog";

export default (args: { dispatchDataV2: any}) => (candidacyId: string, keyValuesPairs: any) => {
    
    args.dispatchDataV2({type: "UPDATE_CANDIDACY", value: {candidacyId: candidacyId, keyValuesPairs: keyValuesPairs}});

}
